import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.number.constructor";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bgContain from '../components/bgContain';
import { ChartPieCircle, ChartBarLine, ChartMap } from '_c/charts';
import { get_device_info, get_alarm_info, device_year_increase, alarm_list, indexProject_list } from '@/api/pests';
export default {
  data: function data() {
    return {
      zoom: 5,
      center: [],
      //设备数据详情
      projectDetails: {
        address: null,
        alarm_count: null,
        building_name: null,
        count: null,
        customer_user: null,
        id: null,
        lat: null,
        lng: null,
        maintain_user: [],
        project_code: "",
        project_name: "",
        tel: ""
      },
      showDetails: false,
      //项目名称：[坐标]
      geoCoordMap: {},
      //项目value name
      mapData: [],
      deviceTotal: 0,
      //设备总数
      deviceData: [{
        value: 0,
        name: '在线设备'
      }, {
        value: 0,
        name: '离线设备'
      }, {
        value: 0,
        name: '故障设备'
      }],
      alertTotile: 0,
      //告警总数
      alertData: [],
      deviceYearIncrease: [],
      alertListData: [],
      reqBase: {
        page: 1,
        page_size: 10
      },
      columns1: [{
        title: '项目名称',
        key: 'project_name',
        align: 'left',
        tree: true
      }, {
        title: '设备数量',
        key: 'count',
        width: 100,
        align: 'center'
      }],
      projectList: [],
      projectTotal: 0,
      height: 200,
      listLoading: false
    };
  },
  components: {
    bgContain: bgContain,
    ChartPieCircle: ChartPieCircle,
    ChartBarLine: ChartBarLine,
    ChartMap: ChartMap
  },
  methods: {
    close: function close() {
      this.showDetails = false;
    },
    clickProject: function clickProject(params) {
      var index = params.dataIndex;
      this.onRowClick(this.mapData[index], index, 1);
    },

    /**
     * 设备统计 
     */
    getDeviceInfo: function getDeviceInfo() {
      var _this = this;

      get_device_info().then(function (res) {
        if (res.result === 0) {
          var data = res.body;

          _this.$set(_this.deviceData[0], 'value', data.did_online);

          _this.$set(_this.deviceData[1], 'value', data.did_offline);

          _this.$set(_this.deviceData[2], 'value', data.did_fault);

          _this.deviceTotal = data.did_total;
        }
      });
    },

    /**
     * 获取报警统计
     */
    getAlarmInfo: function getAlarmInfo() {
      var _this2 = this;

      this.alertData.splice(0);
      get_alarm_info().then(function (res) {
        if (res.result === 0) {
          var list = res.body.list;
          _this2.alertTotile = res.body.alarm_total;

          for (var i in list) {
            var item = list[i];

            _this2.alertData.push({
              name: item.cate_name,
              value: item.count
            });
          }
        }
      });
    },

    /**
     * 近一年的新增设备统计
     */
    getDeviceYearIncrease: function getDeviceYearIncrease() {
      var _this3 = this;

      this.deviceYearIncrease.splice(0);
      device_year_increase().then(function (res) {
        if (res.result === 0) {
          var list = res.body || [];

          for (var i in list) {
            _this3.deviceYearIncrease.push({
              value: list[i].num,
              name: list[i].str
            });
          }
        }
      });
    },

    /**
     * 获取未处理的告警
     */
    getUnAlertList: function getUnAlertList() {
      var _this4 = this;

      this.$Notice.destroy();
      this.alertListData.splice(0);
      this.listLoading = true;
      alarm_list({
        page: 1,
        page_size: 30,
        status: 1
      }).then(function (res) {
        _this4.listLoading = false;

        if (res.result === 0) {
          var total = res.body.total;

          if (total > 0) {
            _this4.$Notice.warning({
              duration: 0,
              render: function render(h) {
                return h('div', {
                  style: {
                    cursor: 'pointer',
                    display: 'flex',
                    lineHeight: '80px',
                    'align-content': 'center',
                    color: '#fff'
                  },
                  on: {
                    click: function click() {
                      _this4.$router.push({
                        name: 'policeList',
                        query: {
                          status: 1
                        }
                      });

                      _this4.$Notice.destroy();
                    }
                  }
                }, '您还有' + total + '条报警信息未处理，请及时处理');
              }
            });
          }
        }
      });
    },

    /**
     * 获取告警记录
     */
    getAlertList: function getAlertList() {
      var _this5 = this;

      this.$Notice.destroy();
      this.alertListData.splice(0);
      this.listLoading = true;
      alarm_list({
        page: 1,
        page_size: 30
      }).then(function (res) {
        _this5.listLoading = false;

        if (res.result === 0) {
          _this5.alertListData = res.body.list;
          var total = res.body.total;
        }
      });
    },
    deelData: function deelData(arr) {
      for (var i in arr) {
        var list = arr[i];

        if (list && list.project_list && list.project_list.length > 0) {
          list.children = list.project_list;
          list._showChildren = true;
          this.deelData(list.project_list);
        }
      }
    },

    /**
     * 获取项目及设备统计
     */
    getProjectList: function getProjectList() {
      var _this6 = this;

      this.projectList.splice(0);
      this.mapData.splice(0);
      indexProject_list(_objectSpread({}, this.reqBase, {
        page_size: -1
      })).then(function (res) {
        if (res.result === 0) {
          var data = res.body.list;
          _this6.projectTotal = res.body.total;

          _this6.deelData(data);

          console.log(data);

          for (var i in data) {
            var list = data[i];
            var count = 0;

            _this6.deelData(list);

            for (var j in list.project_list) {
              var item = list.project_list[j];
              var key = item.project_name;
              var value = item.count;
              count += item.count;

              if (item.lng) {
                _this6.mapData.push(_objectSpread({
                  value: value,
                  name: key
                }, item));

                _this6.geoCoordMap[key] = [Number(item.lng), Number(item.lat)]; // console.log(this.mapData)
                // console.log(this.geoCoordMap)
              }
            }

            _this6.projectList.push(_objectSpread({
              count: count,
              project_name: list.company_name
            }, list));
          }
        }
      });
    },
    pageOnchange: function pageOnchange() {},
    alertClick: function alertClick(row) {
      debugger;
      this.$router.push({
        name: 'policeList',
        query: {
          id: row.id
        }
      });
    },

    /**
     * 点击行数时
     */
    onRowClick: function onRowClick(row, index, type) {
      debugger;

      if (type === undefined) {
        if (row.lat) {
          this.projectDetails.maintain_user.splice(0);
          Object.assign(this.projectDetails, row);
          this.showDetails = true;
          this.center = [Number(row.lng), Number(row.lat)];
          this.zoom = 12;
        } else {
          this.$Message.error(row.project_name + '未在地图上标注');
        }
      } else {
        this.projectDetails.maintain_user.splice(0);
        Object.assign(this.projectDetails, row);
        this.showDetails = true;
        this.center = [Number(row.lng), Number(row.lat)];
        this.zoom = 12;
      }
    },
    onResize: function onResize() {
      var tableH = document.getElementById('tableWrapper');
      this.$set(this, 'height', tableH.offsetHeight - 55);
      this.height = tableH.offsetHeight - 55; // console.log(this.height)
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.getProjectList();
    this.getAlertList();
    this.getUnAlertList(); //未处理的告警

    this.getDeviceInfo();
    this.getAlarmInfo();
    this.getDeviceYearIncrease();
    this.$nextTick(function () {
      _this7.onResize();

      window.addEventListener('resize', _this7.onResize);
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.onResize);
    this.$Notice.destroy();
  }
};